import { getActionStatusName } from '@/store/helpers';


/**
 * @callback ChangeLogActionFunction
 * @param {typeof import('./state').default} state
 */

/**
 * @type {ChangeLogActionFunction}
 */
export const getChangeLogsStatus = state => actionName => state.status[getActionStatusName(actionName)] || {};